import SdgNumber from './sdgNumber.js';
export default SdgNumber;
